import { render, staticRenderFns } from "./InvoiceImportDetailsAppraisal.vue?vue&type=template&id=66db3822&"
import script from "./InvoiceImportDetailsAppraisal.vue?vue&type=script&lang=js&"
export * from "./InvoiceImportDetailsAppraisal.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceImportDetailsAppraisal.vue?vue&type=style&index=0&id=66db3822&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports